import { createReducer } from '@reduxjs/toolkit'

import types from './types'

export { default as actions } from './actions'

export type State = null | number

export default createReducer<State>(null, {
  [types.UPDATE_UNREAD_NOTIFICATION_COUNT]: (_, action) => action.payload,
})
